import React, { useEffect, useRef, useState } from 'react';
import queryString from 'query-string';
import { CSSTransition } from 'react-transition-group';
import { Alert, Form, Progress } from 'reactstrap';

import { useLocalization, WithLocalize } from '../../containers/I18nProvider';
import { WithCaptcha } from '../../containers/captcha';

import fibercomLogo from './img/fibercom-logo.png';
import tycSportsPlayLogo from './img/tycsportsplay.svg';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: '',
  });
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true);
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true);
    setError({
      open: false,
      message: '',
    });

    api.userPassLogin(
      {
        username,
        password,
        cp_convert: parameters.cp_convert,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false);
        window.location = `${parameters.redirect_uri}?${queryString.stringify(response)}`;
      })
      .catch((apiError) => {
        const translatedError = translate(apiError.errorCode);
        let message = translate('RequestLoginErrorMessage');

        if (translatedError) {
          message = translatedError;
        } else if (apiError.details) {
          message = apiError.details;
        }

        setOnLogin(false);
        setError({ open: true, message });
      });
  };

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <Form onSubmit={(event) => onSubmit(event)} className="login-fibercom">
        <div className="wrapper-fibercom fadeInDown" ref={nodeRef}>
          <div id="formContent-fibercom">
            <div className="menu1-fibercom">
              <div className="fibercom-brand">
                <img src={fibercomLogo} alt="Fibercom" className="fibercom-brand-main" />
                <div className="fibercom-divider" />
                <img src={tycSportsPlayLogo} alt="TyC Sports Play" className="fibercom-brand-tyc" />
              </div>

              <p className="title-fibercom">{translate('Title')}</p>
              <p className="subtitle-fibercom">{translate('Subtitle')}</p>

              <input
                className="fadeIn second"
                disabled={onLogin}
                onChange={(e) => setUsername(e.target.value)}
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                name="login"
                id="login-fibercom"
                placeholder={translate('PlaceholderUserName')}
              />

              <input
                className="fadeIn third"
                required={true}
                disabled={onLogin}
                onChange={(e) => setPassword(e.target.value)}
                tabIndex={2}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                id="password-fibercom"
                name="password"
                placeholder={translate('PlaceholderPassword')}
              />

              <div className="buttons-fibercom">
                {!onLogin ? (
                  <button
                    type="submit"
                    className="fadeIn fourth"
                    id="entrar-fibercom"
                    disabled={!props.turnstileSuccess}
                  >
                    <span className="entrar-text">{translate('ButtonEnter')}</span>
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </div>

              <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />

              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </CSSTransition>
  );
};

export default WithCaptcha(WithLocalize(LoginForm), {
  useInsideForm: true,
  style: { marginTop: '1.25rem' },
});
